import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PostHogProvider } from "posthog-js/react";
import posthog from "posthog-js";
import App from "./App";
import "./index.css";

const NOTRACK_KEY = "pick3_notrack";

/**
 * Check for analytics opt-out via query param or localStorage.
 * Once set via ?notrack=1, persists in localStorage for future sessions.
 */
const checkNoTrack = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const notrackParam = urlParams.get("notrack") === "1";
  const notrackStored = localStorage.getItem(NOTRACK_KEY) === "1";

  if (notrackParam) {
    localStorage.setItem(NOTRACK_KEY, "1");
    return true;
  }
  return notrackStored;
};

const shouldDisableTracking = checkNoTrack();

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-11-30",
} as const;

// Opt out of PostHog tracking if notrack is enabled
// This prevents ALL capture() calls from sending data
if (shouldDisableTracking) {
  posthog.opt_out_capturing();
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={posthogOptions}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  </React.StrictMode>
);

